<template>
  <el-container direction="vertical" id="insureManagement">
    <el-row class="row-bg">
      <!-- 头部 -->
      <el-header>
        <el-col :span="24" style="text-align: center">
          <div>
            <span class="p-title">{{dynamicValidateForm.projectName}}</span>
          </div>
        </el-col>
        <el-col :span="14" :push="5" class="my-step">
          <el-steps :active="1" align-center>
            <el-step title="选择投保方案"></el-step>
            <el-step title="填写投保信息"></el-step>
            <el-step title="在线支付"></el-step>
            <el-step title="完成投保"></el-step>
          </el-steps>
        </el-col>
      </el-header>
    </el-row>
    <el-main>
      <!-- 表单计划 -->
      <el-row>
        <el-col :span="16" :push="4">
          <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="204px" class="demo-dynamic"
                   style="text-align: left">
            <el-card class="box-card">
              <div class="box-card-div-title userInfo">
                <div class="header">投保方案</div>
              </div>
              <span v-for="(item, index) in dynamicValidateForm.skuSpecList">
                <el-form-item
                  v-if="$$.isValidObj(dynamicValidateForm.skuSpecList[dynamicValidateForm.skuSpecList.length-1].value[0].specName) && item.value[0].type !== 4 && item.value[0].type !== 6 "
                  :key="index" :label="item.name" class="form-item-label">
                  <el-select v-if="item.value.length === 1 && item.name !== '投保单位' && item.name !== '保险方案' "
                             class="form-item-input my-input select-arrowhead" :disabled="true"
                             v-model="dynamicValidateForm.skuSpecNameList[index]" style="width: 250px">
                    <el-option
                      v-for="i in item.value"
                      :key="i.id"
                      :label="i.specName"
                      :value="i.specName">
                    </el-option>
                  </el-select>
                  <el-button v-else-if="item.name === '保险方案' "
                             :class="dynamicValidateForm.planId === plan.id ? 'true' : 'false'"
                             style="width: 200px;min-width: 144px;border: 0px"
                             v-for="plan in dynamicValidateForm.planIds" :key="plan.id" @click="planChange(plan.id)"> {{plan.name}}
                  </el-button>
                  <el-select v-else class="form-item-input my-input"
                             v-model="dynamicValidateForm.skuSpecNameList[index]" style="width: 250px"
                             @change="hurtChange(1, item.value[0].type, index)">
                    <el-option
                      v-for="i in item.value"
                      :key="i.id"
                      :label="i.specName"
                      :value="i.specName">
                    </el-option>
                  </el-select>
                </el-form-item>
                <span   v-if=" $$.isValidObj(dynamicValidateForm.attachSkuSpecName) && dynamicValidateForm.attachSkuSpecName !== '0'">
                <el-form-item
                  v-if="$$.isValidObj(dynamicValidateForm.skuSpecList[dynamicValidateForm.skuSpecList.length-1].value[0].specName) && (item.value[0].type === 4 || item.value[0].type === 6) "
                  :key="index" :label="item.name" class="form-item-label">
                  <el-select v-if="item.value.length === 1 && item.name !== '投保单位' && item.name !== '保险方案' "
                             class="form-item-input my-input select-arrowhead" :disabled="true"
                             v-model="dynamicValidateForm.skuSpecNameList[index]" style="width: 250px">
                    <el-option
                      v-for="i in item.value"
                      :key="i.id"
                      :label="i.specName"
                      :value="i.specName">
                    </el-option>
                  </el-select>
                </el-form-item>
                </span>
              </span>
            </el-card>
            <el-card class="box-card">
              <div class="box-card-div-title userInfo">
                <div class="header">投保信息</div>
              </div>
              <el-form-item label="投保单位" class="form-item-label">
                <el-input class="form-item-input my-input-left " style="width: calc(100% - 35px);min-width: 144px"
                          v-model="dynamicValidateForm.companyName" placeholder="请填写与营业执照上一致的单位名称（必填)"
                          @input="valueChange()">
                </el-input>
              </el-form-item>
              <el-form-item label="起保日期" class="form-item-label">
                <div class="block">
                  <el-date-picker
                    v-model="beInsuredEffectiveDate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    format="yyyy 年 MM 月 dd 日"
                    align="center"
                    placeholder="请选择"
                    class="my-el-date-picker"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="投保人所在区域" class="form-item-label">
                <el-select @change="areaChange(1)" v-model="provinceId" placeholder="请选择"
                           class="form-item-input my-input">
                  <el-option
                    v-for="item in chinaArea"
                    :key="item.label"
                    :label="item.label"
                    :value="dynamicValidateForm.productId == 100435 ? item.value : item.label">
                  </el-option>
                </el-select>
                <el-select @change="areaChange(2)" v-model="cityId" placeholder="请选择"
                           class="form-item-input my-input">
                  <el-option
                    v-for="item in cityList"
                    :key="item.label"
                    :label="item.label"
                    :value="dynamicValidateForm.productId == 100435 ? item.value : item.label">
                  </el-option>
                </el-select>
                <el-select v-if="isArea" @change="areaChange(3)" v-model="areaId" placeholder="请选择"
                           class="form-item-input my-input">
                  <el-option
                    v-for="item in areaList"
                    :key="item.label"
                    :label="item.label"
                    :value="dynamicValidateForm.productId == 100435 ? item.value : item.label">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="投保人详细地址" class="form-item-label">
                <el-input class="form-item-input my-input-left "
                          v-model="specificAddress"
                          placeholder="请填写营业执照上的注册详细地址"
                ></el-input>
              </el-form-item>
              <el-form-item label="注册时间" class="form-item-label">
                <div class="block">
                  <el-date-picker
                    v-model="beBrithday"
                    value-format="yyyy-MM-dd"
                    type="date"
                    format="yyyy 年 MM 月 dd 日"
                    align="center"
                    placeholder="请选择"
                    class="my-el-date-picker"
                  >
                  </el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="证件类型" class="form-item-label">
                <el-select v-model="idType" placeholder="请选择"
                           class="form-item-input my-input" style="width: 200px">
                  <el-option label="社会统一信用代码" :value=6></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="证件号码" class="form-item-label">
                <el-input class="form-item-input my-input-left "
                          v-model="socialCreditCode"
                          placeholder="请填写投保单位证件号码"
                          maxlength="18"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人姓名" class="form-item-label">
                <el-input class="form-item-input my-input-left "
                          v-model="legalPerson"
                          placeholder="联系人姓名必须真实填写"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人手机号" class="form-item-label">
                <el-input class="form-item-input my-input-left "
                          v-model="mobile"
                          maxlength="11"
                          @input="valueChange()"
                          placeholder="联系人手机号码必须真实填写"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人地址" class="form-item-label">
                <el-input class="form-item-input my-input-left "
                          v-model="address"
                          placeholder="此地址供保险公司邮寄发票时使用"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人邮箱" class="form-item-label">
                <el-input class="form-item-input my-input-left "
                          v-model="workEmail"
                          placeholder="此邮箱为电子发票、电子保单发送邮箱"
                ></el-input>
              </el-form-item>
              <span v-if="this.dynamicValidateForm.productId !== 100435">

              <el-form-item label="餐厅类型" class="form-item-label">
                <el-select v-model="restaurantType" placeholder="请选择"
                           class="form-item-input my-input" style="width: 200px">
                  <el-option label="西餐厅" value='01'></el-option>
                  <el-option label="中餐厅" value='02'></el-option>
                  <el-option label="快餐厅" value='03'></el-option>
                  <el-option label="火锅店" value='04'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="建筑结构" class="form-item-label">
                <el-select v-model="buildingStructure" placeholder="请选择"
                           class="form-item-input my-input" style="width: 200px">
                  <el-option label="钢结构" value='01'></el-option>
                  <el-option label="钢筋混凝土" value='02'></el-option>
                  <el-option label="混合结构" value='03'></el-option>
                  <el-option label="砖木结构" value='04'></el-option>
                  <el-option label="其他结构" value='05'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="面积(㎡)" class="form-item-label">
                <el-input class="form-item-input my-input" @input="areaCount()" style="width: 200px;"
                          v-model="area" placeholder="请输入餐厅面积(㎡)"></el-input>
              </el-form-item>
              <el-form-item v-if="dynamicValidateForm.planId === 1695" label="标的物类型" class="form-item-label">
                <el-select v-model="itemTypeL" placeholder="请选择"
                           class="form-item-input my-input" style="width: 200px">
                  <el-option label="纯建筑物" value='01'></el-option>
                  <el-option label="纯机器设备" value='02'></el-option>
                  <el-option label="包含建筑物、机器设备等的纯固定资产" value='03'></el-option>
                  <el-option label="纯流动资产" value='04'></el-option>
                  <el-option label="固定资产和流动资产均有" value='05'></el-option>
                </el-select>
                <el-button class="header-row-col-button-failure"
                           @click="addTargetListDialogVisible = true">添加设备
                </el-button>
              </el-form-item>
              <el-dialog
                title="新增设备"
                :visible.sync="addTargetListDialogVisible"
                width="424px"
                center>
                <el-form-item label="机器名称" class="form-item-label-add">
                  <el-input class="form-item-input-add my-input-add" style="width: 264px"
                            v-model="addTargetListData.machineName"
                            placeholder="请输入机器名称"
                            @input="areaCount()"
                  ></el-input>
                </el-form-item>
                <el-form-item label="数量" class="form-item-label-add">
                  <el-input class="form-item-input-add my-input-add" style="width: 264px"
                            v-model="addTargetListData.number"
                            placeholder="请输入机器数量"
                            @input="areaCount()"
                  ></el-input>
                </el-form-item>
                <el-form-item label="保额" class="form-item-label-add">
                  <el-input class="form-item-input-add my-input-add" style="width: 264px"
                            v-model="addTargetListData.insuredAmount"
                            placeholder="请输入机器保额"
                            @input="areaCount()"
                  ></el-input>
                </el-form-item>
                <div class="dialog-footer">
                  <el-button class="header-row-col-button-failure-add" @click="cancelTargetListAddDialogVisible">取 消</el-button>
                  <el-button type="primary" class="header-row-col-button-success-add" @click="submitTargetListAddDialogVisible">确定</el-button>
                </div>
              </el-dialog>
              <el-form-item v-if="dynamicValidateForm.planId === 1695" label="设备清单" class="form-item-label">
                <el-table
                  :data="targetList"
                  v-loading="loading"
                  border
                  max-height="500"
                  @selection-change="handleSelectionChangeTargetList"
                  class="my-el-table" style="margin-left: 10px;">
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="index"
                    type="index"
                    label="序号"
                    width="50">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="machineName"
                    label="设备名称">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="number"
                    label="数量">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="insuredAmount"
                    label="保额/元">
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="55">
                    <template slot-scope="scope">
                      <el-link type="warning"
                               @click.native.prevent="deleteBeInsureTableData(scope.$index, targetList)">删除
                      </el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
              </span>
              <!--<el-form-item v-if="dynamicValidateForm.planId === 1695" label="机器设备名称" class="form-item-label">
                <el-input class="form-item-input my-input" @input="areaCount()" style="width: 200px;"
                          v-model="machineName" placeholder="请输入机器设备名称"></el-input>
              </el-form-item>
              <el-form-item v-if="dynamicValidateForm.planId === 1695" label="数量" class="form-item-label">
                <el-input class="form-item-input my-input" @input="areaCount()" style="width: 200px;"
                          v-model="number" placeholder="请输入机器数量"></el-input>
              </el-form-item>
              <el-form-item v-if="dynamicValidateForm.planId === 1695" label="保额" class="form-item-label">
                <el-input class="form-item-input my-input" @input="areaCount()" style="width: 200px;"
                          v-model="insuredAmount" placeholder="请输入机器保额"></el-input>
              </el-form-item>-->
              <el-form-item v-if="dynamicValidateForm.planId === 1695" label="被保险机器设备所在地" class="form-item-label">
                <el-input class="form-item-input my-input-left"
                          :value="provinceName + cityName + areaName + specificAddress" :disabled="true"></el-input>
              </el-form-item>
            </el-card>
            <el-card   v-if="$$.isValidObj(dynamicValidateForm.attachSkuSpecName) && dynamicValidateForm.attachSkuSpecName !== '0' " class="box-card underwriterDetailed">
              <div class="box-card-div-title" style="width: 145px">
                <div class="header" id="beInsureLocation">被保险人清单</div>
              </div>
             <!-- <el-form-item label="人员说明" class="form-item-label">
                <div>
                    <span v-for="item in occRepeatList">
                      <span
                        class="header-span">{{item.occName}}，职业代码：{{item.realityOccCode}}，人数：{{item.groupSize}}</span><br>
                    </span>
                </div>
              </el-form-item>-->
              <!--<el-form-item label="职业选择" class="form-item-label">
                &lt;!&ndash;<el-select  class="form-item-input my-input" v-model="occOneId" placeholder="请选择" @change="occChange(1,occOneId)">
                  <el-option
                    v-for="i in occupationList"
                    :key="i.id"
                    :label="i.name"
                    :value="i.id">
                  </el-option>
                </el-select>
                <el-select class="form-item-input my-input" v-model="occTwoId" placeholder="请选择" @change="occChange(2,occTwoId)">
                  <el-option
                    v-for="i in occTwoList"
                    :key="i.id"
                    :label="i.name"
                    :value="i.id">
                  </el-option>
                </el-select>&ndash;&gt;
                <el-select class="form-item-input my-input" placeholder="请选择" @change="occChange(3,occThreeId)"
                           v-model="occThreeId">
                  <el-option
                    v-for="i in occThreeList"
                    :key="i.id"
                    :label="i.name"
                    :value="i.id">
                  </el-option>
                </el-select>
                <el-popover
                  placement="right"
                  width="500"
                  :content="'请选择职业后再上传被保人信息!'"
                  trigger="hover">
                  <el-button slot="reference" class="specialTip"></el-button>
                </el-popover>
              </el-form-item>-->
              <el-form-item label="批量导入" class="form-item-label">
                <el-button class="header-row-col-button-success"><a id="a" style="display: inline"
                                                                    @click="dynamicValidateForm.productId == '100435' ? $$.download('https://pic.xiaobaibao.com/system/reportTemp/2021/8/412fc4b15f15498d814a165d27ad09c5.xls','被保险人清单模板') : $$.download('https://pic.xiaobaibao.com/system/reportTemp/2021/8/787f5659d4834d50bd2119c89dd012a1.xls','被保险人清单模板')"
                >下载模板</a></el-button>
                <el-upload style="display: inline-block"
                           action="#"
                           :before-upload="uploadFileExcel"
                           :show-file-list="false"
                >
                  <el-button class="header-row-col-button-failure">上传被保险人清单</el-button>
                </el-upload>
                <el-button class="header-row-col-button-failure" @click="deleteBeInsureTableDataBatch">批量删除被保险人
                </el-button>
              </el-form-item>
              <el-form-item label="单个新增" class="form-item-label">
                <el-button class="header-row-col-button-failure"  @click="addDialogVisible = true">新增
<!--                           @click="$$.isValidObj(occThreeId) ? addDialogVisible = true : $message.error('请先选择职业!')">新增-->
                </el-button>
              </el-form-item>
              <el-dialog
                title="新增被保险人员"
                :visible.sync="addDialogVisible"
                width="424px"
                center>
                <el-form-item label="职业选择" class="form-item-label-add">
                  <!--<el-select  class="form-item-input my-input" v-model="occOneId" placeholder="请选择" @change="occChange(1,occOneId)">
                    <el-option
                      v-for="i in occupationList"
                      :key="i.id"
                      :label="i.name"
                      :value="i.id">
                    </el-option>
                  </el-select>
                  <el-select class="form-item-input my-input" v-model="occTwoId" placeholder="请选择" @change="occChange(2,occTwoId)">
                    <el-option
                      v-for="i in occTwoList"
                      :key="i.id"
                      :label="i.name"
                      :value="i.id">
                    </el-option>
                  </el-select>-->
                  <el-select class="form-item-input-add my-input-add" style="width: 264px"  placeholder="请选择" @change="occChange(3,occThreeId)"
                             v-model="occThreeId">
                    <el-option
                      v-for="i in occThreeList"
                      :key="i.id"
                      :label="i.name"
                      :value="i.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="姓名" class="form-item-label-add">
                  <el-input class="form-item-input-add my-input-add" style="width: 264px"
                            v-model="addBeInsureData.addBeInsureName"
                            placeholder="请输入被保险人员姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="证件类型" class="form-item-label-add">
                  <el-select v-model="addBeInsureData.addBeInsureIdType" placeholder="请选择"
                             class="form-item-input-add my-input-add" style="width: 264px">
                    <el-option label="身份证" :value=1></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="证件号码" class="form-item-label-add">
                  <el-input class="form-item-input-add my-input-add" style="width: 264px"
                            v-model="addBeInsureData.addBeInsureIdCard"
                            placeholder="请输入被保险人证件号码"
                            @change="addBeInsureIdCardChange"
                  ></el-input>
                </el-form-item>
                <el-form-item label="性别" class="form-item-label-add">
                  <el-select v-model="addBeInsureData.addBeSex" placeholder="请选择"
                             class="form-item-input-add my-input-add" style="width: 264px">
                    <el-option label="男性" value="M"></el-option>
                    <el-option label="女性" value="F"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="出生日期" class="form-item-label-add">
                  <div class="block">
                    <el-date-picker
                      v-model="addBeInsureData.addBeBirthday"
                      type="date"
                      align="center"
                      placeholder="请选择"
                      value-format="yyyy-MM-dd"
                      class="my-el-date-picker-add">
                    </el-date-picker>
                  </div>
                </el-form-item>

                <el-form-item label="职业代码" class="form-item-label-add" hidden>
                  <!--<el-select v-model="addBeInsureData.addRealityOccCode" placeholder="请选择"
                             class="form-item-input-add my-input-add" style="width: 264px" :disabled="true">
                    <el-option
                      v-for="item in  dynamicValidateForm.cards"
                      :key="item.realityOccCode"
                      :label="item.occThreeName"
                      :value="item.realityOccCode">
                    </el-option>
                  </el-select>-->
                  <div class="form-item-input-add my-input-add"
                       style="width: 264px;text-align: center;padding: 0 30px 0 10px;">{{realityOccCode}}
                  </div>
                </el-form-item>
                <div class="dialog-footer">
                  <el-button class="header-row-col-button-failure-add" @click="cancelAddDialogVisible">取 消</el-button>
                  <el-button type="primary" class="header-row-col-button-success-add" @click="submitAddDialogVisible">确
                    定
                  </el-button>
                </div>
              </el-dialog>
              <el-form-item label="人员清单" class="form-item-label">
                <el-table
                  :data="beInsureTableData"
                  v-loading="loading"
                  border
                  max-height="500"
                  @selection-change="handleSelectionChange"
                  class="my-el-table" style="margin-left: 0;">
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="index"
                    type="index"
                    label="序号"
                    width="50">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="beInsureName"
                    label="姓名">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="beInsureIdType"
                    label="证件类型"
                    width="80">
                    <template slot-scope="scope">
                      <div v-if="scope.row.beInsureIdType === 1">身份证</div>
                      <!--<div v-if="scope.row.beInsureIdType === 3">中国护照</div>
                      <div v-if="scope.row.beInsureIdType === 5">港澳台通行证</div>-->
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="beInsureIdCard"
                    label="证件号码"
                    width="182">
                    <template slot-scope="scope">
                      <div style="text-align: center">
                        <p style="margin-top:0;margin-bottom:0">{{scope.row.beInsureIdCard}}</p>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="beSex"
                    label="性别"
                    width="55">
                    <template slot-scope="scope">
                      <div v-if="scope.row.beSex === 'M'">男性</div>
                      <div v-if="scope.row.beSex === 'F'">女性</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="beBirthday"
                    label="出生日期"
                    value-format="yyyy-MM-dd"
                    width="101">
                    <template slot-scope="scope">
                      <div style="text-align: center">
                        <p style="margin-top:0;margin-bottom:0">{{scope.row.beBirthday}}</p>
                      </div>
                    </template>
                  </el-table-column>
                  <!--<el-table-column
                    align="center"
                    prop="realityOccCode"
                    label="职业代码"
                    width="102">
                    <template slot-scope="scope">
                      <div style="text-align: center">
                        <p style="margin-top:0;margin-bottom:0">{{scope.row.realityOccCode}}</p>
                      </div>
                    </template>
                  </el-table-column>-->
                  <el-table-column
                    align="center"
                    prop="occName"
                    label="职业名称"
                    width="102">
                    <template slot-scope="scope">
                      <div style="text-align: center">
                        <p style="margin-top:0;margin-bottom:0">{{scope.row.occName}}</p>
                      </div>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column
                     align="center"
                     prop="azcnCode"
                     label="职业类别"
                     width="102">
                     <template slot-scope="scope">
                       <div style="text-align: center">
                         <p style="margin-top:0;margin-bottom:0">{{scope.row.azcnCode}}</p>
                       </div>
                     </template>
                   </el-table-column>-->
                  <el-table-column
                    label="操作"
                    width="55">
                    <template slot-scope="scope">
                      <el-link type="warning"
                               @click.native.prevent="deleteBeInsureTableData(scope.$index, beInsureTableData)">删除
                      </el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="ErrorReminder" v-if="uploadErrorReminder.errorReminderState">
                  <div style="color: #FF7052">
                    本次导入共<span>{{uploadErrorReminder.countSize}}</span>人，
                    成功导入<span>{{uploadErrorReminder.successSize}}</span>人，
                    <span>{{uploadErrorReminder.errorSize}}</span>人导入失败，请重新导入，或者重新选择人员！
                  </div>
                  <div style="font-weight: bold;font-size: 1.125rem;color: #333333;margin: 10px auto">错误提醒：</div>
                  <div style="color: #666666;height: 200px;overflow: auto;padding: 5px 10px">
                    <div v-for="(item, index) in uploadErrorReminder.errorReminderList">
                      <span>{{index+1}}</span>、
                      姓名：<span>{{item.name}}</span>，
                      证件号码：<span>{{item.idCard}}</span>
                      （错误原因：<span>{{item.errorMsg}}</span>）
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-card>
            <el-card class="box-card" v-if="this.dynamicValidateForm.productId === 100435">
              <div class="box-card-div-title userInfo">
                <div class="header">发票信息</div>
              </div>
              <el-form-item label="是否需要" class="form-item-label-big">
                <el-radio-group v-model="needInvoices">
                  <el-radio-button class="my-button" :label="true">需要</el-radio-button>
                  <el-radio-button class="my-button" :label="false">不需要</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <span v-if="needInvoices">
                  <el-form-item label="发票类型" class="form-item-label-big">
                  <div>
                    <el-radio-group v-model="receiptType">
                      <el-radio-button class="my-button" :label="2">增值税普通发票(电子发票)</el-radio-button>
                      <!-- <el-radio-button class="my-button" :label="3">增值税专用发票(纸质发票)</el-radio-button>-->
                      <!--  <el-radio-button class="my-button" :label="4">增值税普通发票(纸质发票)</el-radio-button>-->
                    </el-radio-group>
                  </div>
                  </el-form-item>
                  <span v-if="receiptType === 2">
                    <el-form-item label="发票内容" class="form-item-label-big"></el-form-item>
                    <el-form-item label="发票抬头" class="form-item-label">
                      <el-input :disabled="true" class="form-item-input my-input-left "
                                v-model="dynamicValidateForm.companyName"
                                placeholder="请输入发票抬头"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号" class="form-item-label">
                      <el-input class="form-item-input my-input-left "
                                v-model="socialCreditCode" :disabled="true"
                                placeholder="请输入纳税人识别号"
                      ></el-input>
                    </el-form-item>
                  </span>
                  <span v-else-if="receiptType === 3">
                   <el-form-item label="发票内容" class="form-item-label-big"></el-form-item>
                    <el-form-item label="发票抬头" class="form-item-label">
                      <el-input :disabled="true" class="form-item-input my-input-left "
                                v-model="dynamicValidateForm.companyName"
                                placeholder="请输入发票抬头"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号" class="form-item-label">
                      <el-input class="form-item-input my-input-left "
                                v-model="socialCreditCode" :disabled="true"
                                placeholder="请输入纳税人识别号"
                      ></el-input>
                    </el-form-item>
                </span>
                <span v-else-if="receiptType === 4">
                     <el-form-item label="发票内容" class="form-item-label-big"></el-form-item>
                    <el-form-item label="发票抬头" class="form-item-label">
                      <el-input :disabled="true" class="form-item-input my-input-left "
                                v-model="dynamicValidateForm.companyName"
                                placeholder="请输入发票抬头"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号" class="form-item-label">
                      <el-input class="form-item-input my-input-left "
                                v-model="socialCreditCode" :disabled="true"
                                placeholder="请输入纳税人识别号"
                      ></el-input>
                    </el-form-item>
                </span>
                </span>
            </el-card>
            <el-card class="box-card">
              <div class="box-card-div-title supportPlan">
                <div class="header">受益人信息</div>
              </div>
              <el-form-item label="受益人" class="form-item-label">
                <el-input class="form-item-input my-input" :disabled="true" value="法定受益人"></el-input>
              </el-form-item>
            </el-card>
            <el-card class="box-card">
              <el-form-item label="推广人" class="form-item-label">
                <el-input class="form-item-input my-input" :disabled="true" :value="userMobile"></el-input>
              </el-form-item>
            </el-card>
            <template>
              <div style="word-break : break-all;display: inline-flex">
                <!-- `checked` 为 true 或 false -->
                <el-checkbox v-model="checked" style="padding-right: 3px"></el-checkbox>
                <span class="el-checkbox-span-a" style="color: #666">
                本人已阅读并知悉同意
                  <!--<a class="special" style="color: #ff7052;display: contents" target="_blank" href="https://pic.xiaobaibao.com/system/reportTemp/2021/5/748c1708b38b4fb0972179acb1ac0733.pdf">《投保声明》、</a>
                  <a class="special" style="color: #ff7052;display: contents" target="_blank" href="https://pic.xiaobaibao.com/system/reportTemp/2021/5/33c09ddccb4545af8fb577de621e27fa.pdf">《适用条款》</a>-->
                  <a class="special" v-for="i in InsuranceClauseTypeOne" target="_blank" :href="i.tikuanUrl" style="color: #ff7052;display: contents">《{{i.tikuanName.replace('.pdf','')}}》<span>、</span></a>
                  <a class="special" v-for="(i,index) in InsuranceClauseTypeZero" target="_blank" :href="i.tikuanUrl" style="color: #ff7052;display: contents">《{{i.tikuanName.replace('.pdf','')}}》<span v-if="index+1 !== InsuranceClauseTypeZero.length">、</span></a>
              </span>
              </div>
            </template>
            <div class="submitOrder">
              <el-button @click="submitOrder" class="header-button-order-add">提交订单</el-button>
            </div>
          </el-form>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script type="text/javascript">

  import {Loading} from 'element-ui';
  import baseUrl from '../../../tool/baseUrl';

  export default {
    name: "siNoSafeInsureDetails",
    data() {
      return {
        dynamicValidateForm: {
          formItemPlanName: '保险方案',
          companyName: '',
          guaranteePeriod: '',
          insuranceAge: '',
          planId: '',
          planIds: [],
          skuSpecListAll: [],
          skuSpecList: [{
            value: [{
              specName: ''
            }]
          }],
          skuSpecNameList: [],
          attachSkuSpecName: '',
          attachSkuTrueSpecName:'',
          skuList: [],
          groupSize: '',
          skuInfo: '',
          beShareToken: '',
          productId:''
        },
        pickerOptions: {
          disabledDate: this.disabledDate
        },
        //-- 行业类别
        restaurantType: '',
        // 建筑结构
        buildingStructure: '',
        // 面积
        area: '',
        // 标的物类型
        itemTypeL: '',
        // 机器设备列表
        targetList : [
          /*{
            // 机器设备名称
            machineName: '',
            // 机器设备数量
            number: '',
            // 机器保额
            insuredAmount: ''
          }*/
        ],
        // 机器设备被选中数据
        targetListSelection: [],
        addTargetListDialogVisible: false, // 添加被保人按钮弹出框
        // 新增设备map
        addTargetListData: {
          // 机器设备名称
          machineName: '',
          // 机器设备数量
          number: '',
          // 机器保额
          insuredAmount: ''
        },
        //-- 职业信息
        occupationList: [],
        occTwoList: [],
        occThreeList: [],
        occOneId: '',
        occOneName: '',
        occTwoId: '',
        occTwoName: '',
        occThreeId: '',
        occThreeName: '',
        realityOccCode: '',
        azcnCode: '',
        occRepeatList: [],
        //-- 投保信息
        addToDay: 0,
        beInsuredEffectiveDate: '',// 起保日期
        chinaArea: this.sinosafeAccidentDistrict.chinaAreaList(),
        cityId: '', // 	城市ID two
        provinceId: '', // 	省份ID one
        areaId: '', // 	地区ID three
        cityName: '', // 	城市名称
        // 判断是否有第三级
        isArea: true,
        provinceName: '', // 	省份名称
        areaName: '', // 地区名称
        socialCreditCode: '', // 证件号码
        address: '', // 联系人具体地址
        specificAddress: '', // 公司具体地址
        mobile: '',// 联系人手机号
        legalPerson: '', // 联系人
        workEmail: '', // 联系人邮箱
        idType: '',
        cityList: [],
        areaList: [],
        beBrithday: '',
        //-- 被保人
        ageMin: 0,
        ageMax: 0,
        addBeInsureData: {
          addBeInsureName: '',     // 被保人姓名
          addBeBirthday: '',     // 被保人出生日期
          addBeSex: '',          // 被保人性别
          addBeInsureIdCard: '',  // 被保人证件号
          addBeInsureIdType: '', // 被保人证件类型
        },
        addDialogVisible: false, // 添加被保人按钮弹出框
        loading: false,
        beInsureTableData: [],
        beInsureSelection: [], // 被保人选中数据
        uploadErrorReminder: {
          errorReminderState: false,
          errorReminderList: [],
          countSize: 0,
          errorSize: 0,
          successSize: 0,
        },
        //-- 发票信息
        needInvoices: false,
        receiptType: 2,
        bankTypeList: [],
        //-- 投保token
        requestToken: '',
        checked: false,
        submitOrderData: {},
        InsuranceClauseTypeZero : [],
        InsuranceClauseTypeOne : [],
        //-- 推广人账号
        userMobile: ''
      };
    },
    methods: {
      //-- 职业列表去重展示
      occRepeat() {
        this.occRepeatList = [];
        let occMap = {};
        this.beInsureTableData.forEach(item => {
          if (!occMap[item.occName]) {
            item.groupSize = 1;
            this.occRepeatList.push(item);
            occMap[item.occName] = 1;
          } else {
            this.occRepeatList.forEach(count => {
              if (count.occThreeId === item.occThreeId) count.groupSize += 1;
            });
          }
        });
      },
      // -- 上传被保人列表Excel文件
      uploadFileExcel(file) {

        if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
          file.type !== 'application/vnd.ms-excel'
        ) {
          this.$message.error('只能上传xlsx文件');
          return false;
        }
       /* if (!this.$$.isValidObj(this.occThreeId)) {
          this.$message.error('请先选择职业!');
          return false;
        }*/
        const formData = new window.FormData();
        formData.append('file', file);
        formData.append('formType', '40');
        formData.append('formId', this.dynamicValidateForm.productId);
        let loadingInstance = this.Loading.service({fullscreen: true});

        this.loading = true;
        this.axios.post('/upload/attachment/upload',
          formData,
          {headers: {"Content-Type": "multipart/form-data"}},
        ).then((response) => {
          this.loading = false;
          let data = response.data;

          if (data.success) {
            this.uploadErrorReminder.errorReminderList = [];
            this.uploadErrorReminder.errorReminderState = false;
            this.uploadErrorReminder.countSize = data.datas.ExcelData.length;
            this.uploadErrorReminder.successSize = 0;
            this.uploadErrorReminder.errorSize = 0;
            data.datas.ExcelData.forEach(item => {
              let isPush = true;
              try {
                this.beInsureTableData.forEach(user => {
                  if (item.idCard === user.beInsureIdCard) {
                    item.errorMsg = '人员重复！';
                    this.uploadErrorReminder.errorReminderState = true;
                    this.uploadErrorReminder.errorSize += 1;
                    this.uploadErrorReminder.errorReminderList.push(item);
                    throw new Error;
                  } else if (this.$$.constant.beInsureIdTypeOneReg.test(item.idCard) === false) {
                    item.errorMsg = '证件号码错误';
                    this.uploadErrorReminder.errorReminderState = true;
                    this.uploadErrorReminder.errorSize += 1;
                    this.uploadErrorReminder.errorReminderList.push(item);
                    throw new Error;
                  }
                });
              } catch (e) {
                isPush = false;
              }
              if (isPush) {
                let map = {};
               /* map.beInsureName = item.name;
                map.realityOccCode = this.realityOccCode;
                map.occName = this.occThreeName;
                map.azcnCode = this.azcnCode;
                map.occOneName = this.occOneName;
                map.occTwoName = this.occTwoName;
                map.beBirthday = item.birthday;
                map.beSex = item.sex;
                map.beInsureIdCard = item.idCard;
                map.beInsureIdType = item.idType;*/
                let occCodeList = item.realityOccCode.split("-");
                // console.log(occCodeList);
                map.beInsureName = item.name;
                map.realityOccCode = occCodeList[1];
                map.occName = occCodeList[0];
                // map.azcnCode = this.azcnCode;
                // map.occOneName = this.occOneName;
                // map.occTwoName = this.occTwoName;
                map.beBirthday = item.birthday;
                map.beSex = item.sex;
                map.beInsureIdCard = item.idCard;
                map.beInsureIdType = item.idType;
                // console.log(map);
                this.beInsureTableData.push(map);
                this.uploadErrorReminder.successSize += 1;
              }
            });
            this.occRepeat();
            this.$message.success("导入成功");
          } else {
            this.$message.error(data.msg);
          }
        });
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        return false;
      },
      //-- 身份证转换 - 性别、出生日期
      addBeInsureIdCardChange() {
        let idCard = this.addBeInsureData.addBeInsureIdCard;

        if (idCard.length >= 18 && this.$$.constant.beInsureIdTypeOneReg.test(idCard) === true) {
          //-- 识别 - 性别
          let cardState = parseInt(idCard.substr(16, 1)) % 2 == 1;
          this.addBeInsureData.addBeSex = cardState ? "M" : "F";

          //-- 识别 - 出生日期
          let birthday = idCard.slice(6, 14);
          birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");   //通过正则表达式来指定输出格式为:1990-01-01
          this.addBeInsureData.addBeBirthday = birthday;
        }
      },
      // -- 选中被保人事件
      handleSelectionChangeTargetList(val) {
        this.targetListSelection = val;
      },
      // -- 选中被保人事件
      handleSelectionChange(val) {
        this.beInsureSelection = val;
      },
      // -- 批量删除被保人
      deleteBeInsureTableDataBatch() {
        this.beInsureSelection.forEach(item => {
          this.beInsureTableData.forEach((beInsure, index) => {
            if (item === beInsure) {
              this.beInsureTableData.splice(index, 1);
            }
          });
        });
        this.occRepeat();
      },
      // -- 删除被保人
      deleteBeInsureTableData(index, rows) {
        rows.splice(index, 1);
        this.occRepeat();
      },
      // -- 新增机器设备提交
      submitTargetListAddDialogVisible() {
        const reg = /^\d+$/;
        this.addTargetListData.machineName = this.addTargetListData.machineName.replace(/[ ]/g,'')
        if (!this.$$.isValidObj(this.addTargetListData.machineName)) {
          this.$message.error("机器设备名称不能为空!");
          return;
        }
        if (!this.$$.isValidObj(this.addTargetListData.number)) {
          this.$message.error("设备数量不能为空!");
          return;
        }
        if (!this.$$.isValidObj(this.addTargetListData.insuredAmount)) {
          this.$message.error("设备保额不能为空!");
          return;
        }
        if (!reg.test(this.addTargetListData.number)) {
          this.$message.error("设备数量只能填写数字!");
          return;
        }
        if (!reg.test(this.addTargetListData.insuredAmount)) {
          this.$message.error("设备保额只能填写数字!");
          return;
        }
        let map = {};
        map.insuredAmount = this.addTargetListData.insuredAmount;
        map.number = this.addTargetListData.number;
        map.machineName = this.addTargetListData.machineName;
        this.targetList.push(map);
        this.addTargetListData.insuredAmount = '';
        this.addTargetListData.number = '';
        this.addTargetListData.machineName = '';
        this.addTargetListDialogVisible = false;
      },
      // -- 新增被保人提交
      submitAddDialogVisible() {
        if (!this.$$.isValidObj(this.addBeInsureData.addBeInsureName)) {
          this.$message.error("被保人姓名不能为空!");
          return;
        }
        if (!this.$$.isValidObj(this.addBeInsureData.addBeBirthday)) {
          this.$message.error("请选择被保人出生日期!");
          return;
        }
        if (!this.$$.isValidObj(this.addBeInsureData.addBeSex)) {
          this.$message.error("请选择被保人性别!");
          return;
        }
        if (!this.$$.isValidObj(this.addBeInsureData.addBeInsureIdCard)) {
          this.$message.error("被保人证件号码不能为空!");
          return;
        }
        if (!this.$$.isValidObj(this.occThreeId)) {
            this.$message.error("请选择被保人职业类型!");
            return;
        }
        if (!this.$$.isValidObj(this.addBeInsureData.addBeInsureIdType)) {
          this.$message.error("请选择被保人证件类型!");
          return;
        }
        if (this.addBeInsureData.addBeInsureIdType === 1 && this.$$.constant.beInsureIdTypeOneReg.test(this.addBeInsureData.addBeInsureIdCard) === false) {
          this.$message.error("身份证格式不正确!");
          return;
        }
        if (this.$$.getAge(this.addBeInsureData.addBeBirthday.replace(/-/g, '')) < this.ageMin || this.$$.getAge(this.addBeInsureData.addBeBirthday.replace(/-/g, '')) > this.ageMax) {
          this.$message.error("投保年龄必须大于" + this.ageMin + "岁小于" + this.ageMax + "岁!");
          return;
        }
        try {
          this.beInsureTableData.forEach(data => {
            if (this.addBeInsureData.addBeInsureIdCard === data.beInsureIdCard) {
              throw new Error("被保人证件号码:" + data.beInsureIdCard + "已存在!");
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
        let map = {};
        map.beInsureName = this.addBeInsureData.addBeInsureName;
        map.realityOccCode = this.realityOccCode;
        map.occName = this.occThreeName;
        map.occOneName = this.occOneName;
        map.occTwoName = this.occTwoName;
        map.azcnCode = this.azcnCode;
        map.beBirthday = this.addBeInsureData.addBeBirthday.toString().replace(/-/g, '');
        map.beSex = this.addBeInsureData.addBeSex;
        map.beInsureIdCard = this.addBeInsureData.addBeInsureIdCard;
        map.beInsureIdType = this.addBeInsureData.addBeInsureIdType;
        this.beInsureTableData.push(map);
        this.addBeInsureData.addBeInsureName = '';
        this.addBeInsureData.addBeBirthday = '';
        this.addBeInsureData.addBeSex = '';
        this.addBeInsureData.addBeInsureIdCard = '';
        this.addBeInsureData.addBeInsureIdType = '';
        this.occRepeat();
        this.addDialogVisible = false;
      },
      // -- 隐藏被保人新增框
      cancelAddDialogVisible() {
        this.addBeInsureData.addBeInsureName = '';
        this.addBeInsureData.addBeBirthday = '';
        this.addBeInsureData.addBeSex = '';
        this.addBeInsureData.addBeInsureIdCard = '';
        this.addBeInsureData.addBeInsureIdType = '';
        this.addDialogVisible = false;
      },
      // -- 隐藏机器设备新增框
      cancelTargetListAddDialogVisible() {
        this.addTargetListData.insuredAmount = '';
        this.addTargetListData.number = '';
        this.addTargetListData.machineName = '';
        this.addTargetListDialogVisible = false;
      },
      disabledDate(time) {
        let _now = Date.now(),
          day = this.addToDay * 24 * 60 * 60 * 1000,
          days = _now + day;
        let after = Date.now(),
            afterDay = 30 *24 *60 *60 *1000,
            afterDays = after + afterDay;
        return time.getTime() < days || time.getTime() > afterDays ;
        //大于当前的禁止，小于7天前的禁止
      },
      //-- 职业变更事件，三级联动
      occChange(i, occId) {
        this.$forceUpdate();
        switch (i) {
          case 1 : {
            this.occupationList.forEach(item => {
              if (item.id === occId) {
                this.occTwoId = '';
                this.occThreeId = '';
                this.occThreeList = [];
                this.occOneName = item.name;
                this.occTwoList = item.children;
              }
            });
            break;
          }
          case 2 : {
            this.occTwoList.forEach(item => {
              if (item.id === occId) {
                this.occThreeId = '';
                this.occTwoName = item.name;
                this.occThreeList = item.children;
              }
            });
            break;
          }
          case 3 : {
            this.occThreeList.forEach(item => {
              if (item.id === occId) {
                this.realityOccCode = item.realityOccCode;
                this.azcnCode = item.azcnCode;
                this.occThreeName = item.name;
              }
            });
            break;
          }
        }
      },
      //-- 点击计划时
      planChange(id) {
        this.axios.post('/management/mobileInsuranceInfo/getInsuranceSkuDetail?insuranceInfoId=' + this.dynamicValidateForm.productId + '&planId=' + id, {}).then((response) => {
          let data = response.data;
          if (data.success) {
            this.dynamicValidateForm.skuSpecList = [];
            this.dynamicValidateForm.groupSize = '';
            this.dynamicValidateForm.skuInfo = {};
            this.dynamicValidateForm.skuSpecListAll = data.datas.skuSpecList;
            this.dynamicValidateForm.skuSpecListAll[id].forEach(item => {
              if (item.value[0].type === 1) {
                this.dynamicValidateForm.skuSpecList.push(item);
                let planName = {};
                planName.name = this.dynamicValidateForm.formItemPlanName;
                planName.value = [{type: ''}];
                this.dynamicValidateForm.skuSpecList.push(planName);
              } else {
                this.dynamicValidateForm.skuSpecList.push(item);
              }
            });
            this.dynamicValidateForm.skuSpecList.forEach(item => {
              if(item.value[0].type === 1){
                this.dynamicValidateForm.guaranteePeriod = item.value[0].specName;
              }else if (item.value[0].type === 6){
                this.dynamicValidateForm.insuranceAge = item.value[0].specName;
              }
            });
            let length = 0;
            this.dynamicValidateForm.skuSpecNameList = [];
            this.dynamicValidateForm.attachSkuSpecName = '';
            this.dynamicValidateForm.skuSpecList.forEach(item => {
              if (item.value.length === 1 && item.name !== this.dynamicValidateForm.formItemPlanName) {
                this.dynamicValidateForm.skuSpecNameList.push(item.value[0].specName);
              } else {
                this.dynamicValidateForm.skuSpecNameList.push('');
              }
              if (length < item.name.length) length = item.name.length;
            });
            this.dynamicValidateForm.planId = id;
          }
        });

        /*$('.form-item-label .el-form-item__label').css('width', `${length*18}px`);
        $('.form-item-label .el-form-item__content').css('margin-left', `${length*18}px`);*/
      },
      // -- 地区改变时间(联系人)
      areaChange(i) {
        this.$forceUpdate();
        switch (i) {
          case 1: {
            // console.log(this.provinceId );
            try {
                this.chinaArea.forEach(item => {
                    if( this.$$.isValidObj(item.value) ){
                        if ( item.value === this.provinceId ){
                            // console.log(item.value );
                            // console.log(item.label );
                            // console.log(item.provinceId );
                            this.cityList = item.children;
                            this.provinceName = item.label;
                            throw new Error;
                        }
                    }else {
                        if ( item.label === this.provinceId ){
                            this.cityList = item.children;
                            this.provinceName = item.label;
                            throw new Error;
                        }
                    }
                });
            } catch (e) {
            }
            this.cityId = '';
            this.areaId = '';
            this.cityName = '';
            this.areaName = '';

            this.isArea = true;
            break
          }
          case 2: {
            // console.log(this.provinceId );
            try {
                this.cityList.forEach(item => {
                    if( this.$$.isValidObj(item.value) ){
                        // console.log(item.value )
                        if ( item.value === this.cityId ){
                            this.areaList = item.children;
                            this.cityName = item.label;
                            throw new Error;
                        }
                    }else {
                        if ( item.label === this.cityId ){
                            this.areaList = item.children;
                            this.cityName = item.label;
                            throw new Error;
                        }
                    }
                });
            } catch (e) {
            }
            /*this.cityList.forEach(item => {
              item.label === this.cityId ? this.areaList = item.children : [];
              item.label === this.cityId ? this.cityName = item.label : '';
            });*/
            this.isArea = true;
            if (this.$$.isEmptyObject(this.areaList)) this.isArea = false;
            this.areaId = '';
            this.areaName = '';
            break
          }
          case 3: {
            try {
                this.areaList.forEach(item => {
                    if( this.$$.isValidObj(item.value) ){
                        // console.log(item.value );
                        if ( item.value === this.areaId ){
                            this.areaName = item.label;
                            throw new Error;
                        }
                    }else {
                        if ( item.label === this.areaId ){
                            this.areaName = item.label;
                            throw new Error;
                        }
                    }
                });
            } catch (e) {
            }
            // this.areaList.forEach(item => {
            //   item.label === this.areaId ? this.areaName = item.label : '';
            // });
            break
          }
        }
      },
      valueChange(){
        this.dynamicValidateForm.companyName = this.dynamicValidateForm.companyName.replace(/[ ]/g,'');
        this.mobile = this.mobile.replace(/[^\d]/g, '');
      },
      hurtChange(i, type, index) {
        this.$forceUpdate();
        if (i === 1 && this.dynamicValidateForm.groupSize < 5) this.dynamicValidateForm.groupSize = '';
        if (i === 1 && type === 7) {
            this.dynamicValidateForm.skuSpecList[index].value.forEach((item, indexOne) => {
                // console.log(item.specName);
                if (item.specName ===  this.dynamicValidateForm.skuSpecNameList[index]){
                    // console.log(item.specName);
                    this.dynamicValidateForm.attachSkuSpecName =  item.specValue;
                    this.dynamicValidateForm.attachSkuTrueSpecName =  item.specName;
                }
            });
        }// this.dynamicValidateForm.attachSkuSpecName = this.dynamicValidateForm.skuSpecNameList[index];
        this.dynamicValidateForm.groupSize = this.dynamicValidateForm.groupSize.replace(/[^\d]/g, '');
        let dataTitle = "";
        try {
          this.dynamicValidateForm.skuSpecList.forEach((item, index) => {
            if (item.name !== this.dynamicValidateForm.formItemPlanName) {
              if (this.dynamicValidateForm.skuSpecList.length - 1 === index && this.dynamicValidateForm.skuSpecNameList[index] === this.dynamicValidateForm.skuSpecList[index].value[0].specName) this.dynamicValidateForm.groupSize = 1;
              if (!this.$$.isValidObj(this.dynamicValidateForm.skuSpecNameList[index])) {
                throw new Error;
              } else {
                dataTitle += this.dynamicValidateForm.skuSpecNameList[index] + '-';
              }
            }
          });
        } catch (e) {
          return;
        }
        dataTitle = dataTitle.substring(0, dataTitle.length - 1);
        let params = {};
        let skuSpec = [];
        skuSpec.push(dataTitle);
        params.insuranceInfoId = this.dynamicValidateForm.productId;
        params.planId = this.dynamicValidateForm.planId;
        params.skuSpec = skuSpec;
        this.axios.post('/management/mobileInsuranceInfo/getskuSpecRateInfo', this.qs.stringify(params,{indices: false})).then((response) => {
          let data = response.data;
          if( data.success ){
            this.dynamicValidateForm.skuInfo = data.data[0];
            if(this.$$.isValidObj(this.dynamicValidateForm.groupSize)) this.premiumCount();
          }
        });
      },
      areaCount() {
        this.$forceUpdate();
        this.area = this.area.replace(/[^\d]/g, '');
        this.addTargetListData.insuredAmount = this.addTargetListData.insuredAmount.replace(/[^\d]/g,'');
        this.addTargetListData.number = this.addTargetListData.number.replace(/[^\d]/g,'');
        this.addTargetListData.machineName = this.addTargetListData.machineName.replace(/[ ]/g,'');
      },
      getInsuranceClause(){
        this.axios.post('/management/mobileInsuranceClause/getInsuranceClause?productId='+this.dynamicValidateForm.productId+'&clauseType=1').then((response) => {
          if(response.data.success){
            this.InsuranceClauseTypeOne = response.data.datas;
          }
        });
        this.axios.post('/management/mobileInsuranceClause/getInsuranceClause?productId='+this.dynamicValidateForm.productId).then((response) => {
          if(response.data.success){
            this.InsuranceClauseTypeZero = response.data.datas;
          }
        });
      },
      getSkuInfo() {
        this.axios.post('/management/mobileInsuranceInfo/getInsuranceSkuDetail?insuranceInfoId=' + this.dynamicValidateForm.productId + '&planId=' + this.dynamicValidateForm.planId + '&beShareToken=' + encodeURIComponent(decodeURIComponent(this.dynamicValidateForm.beShareToken)).replace(/%20/g,'%2B').replace(/\+/g,'%2B')).then((response) => {
          let data = response.data;
          if (data.success) {
            this.addToDay = data.addToDay;
            this.occupationList = data.occupationList;
            this.occThreeList = data.occupationList[0].children[0].children;
            this.dynamicValidateForm.skuSpecListAll = data.datas.skuSpecList;
            this.dynamicValidateForm.skuSpecList = [];
            this.userMobile = data.userMobile;
            let siNoSafeDynamicValidateForm = sessionStorage.getItem('siNoSafeDynamicValidateForm' + this.dynamicValidateForm.productId);
            if (this.$$.isValidObj(siNoSafeDynamicValidateForm)) {
              siNoSafeDynamicValidateForm = JSON.parse(siNoSafeDynamicValidateForm);
              this.dynamicValidateForm = siNoSafeDynamicValidateForm;
            } else {
              data.planList.forEach(item => {
                /*if (item.id !== 1695)*/ this.dynamicValidateForm.planIds.push(item);
              });
              this.dynamicValidateForm.planId = this.dynamicValidateForm.planIds[0].id;
              data.datas.skuSpecList[this.dynamicValidateForm.planIds[0].id].forEach(item => {
                if (item.value[0].type === 6) {
                  this.dynamicValidateForm.skuSpecList.push(item);
                  let planName = {};
                  planName.name = this.dynamicValidateForm.formItemPlanName;
                  planName.value = [{type: ''}];
                  this.dynamicValidateForm.skuSpecList.push(planName);
                } else {
                  this.dynamicValidateForm.skuSpecList.push(item);
                }
              });
              this.dynamicValidateForm.skuSpecList.forEach(item => {
                if(item.value[0].type === 1){
                  this.dynamicValidateForm.guaranteePeriod = item.value[0].specName;
                }else if (item.value[0].type === 6){
                  this.dynamicValidateForm.insuranceAge = item.value[0].specName;
                }
              });

              let length = 0;
              this.dynamicValidateForm.skuSpecList.forEach(item => {
                if (item.value.length === 1 && item.name !== this.dynamicValidateForm.formItemPlanName) {
                  this.dynamicValidateForm.skuSpecNameList.push(item.value[0].specName);
                } else {
                  this.dynamicValidateForm.skuSpecNameList.push('');
                }
                if (length < item.name.length) length = item.name.length;
              });
              $('.form-item-label .el-form-item__label').css('width', `${length * 18}px`);
              $('.form-item-label .el-form-item__content').css('margin-left', `${length * 18}px`);
            }
            this.requestToken = data.orderToken;
            this.dynamicValidateForm.skuSpecList.forEach(item => {
              item.value.forEach(value => {
                if (value.type === 6) {
                  this.ageMin = value.optionMinValue;
                  this.ageMax = value.optionMaxValue;
                }
              })
            });
          }
        });
      },
      // -- 数据校验
      dataIsValid() {
        let isValid = true;
        let reg = /^\d+$/;
        let idTypeSixReg = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/; // 统一社会信用代码正则校验
        let idTypeElevenRge = /[0-9A-HJ-NPQRTUWXY]{9}/; // 组织机构代码正则校验
        let PHONE_REGEX = /^1(3[0-9]|4[57]|5[0-35-9]|7[0135678]|8[0-9])\d{8}$/;  // 手机号正则校验
        let EMAIL_REGEX = /^([a-zA-Z0-9_\.\-])+[\@,\＠](([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;  // 邮箱正则校验
        if (!this.dynamicValidateForm.companyName.trim()) {
          this.$message.error("投保单位不能为空!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.dynamicValidateForm.skuInfo.id)) {
          this.$message.error("保障项目不能为空!");
          return isValid = false;
        }

        // -- 投保数据校验
        if (!this.$$.isValidObj(this.beInsuredEffectiveDate)) {
          this.$message.error("请选择起保日期!");
          return isValid = false;
        }
        /*if (this.$$.dateDifference(this.beInsuredEffectiveDate) < 2) {
          this.$message.error("起保日期必须为三天后!");
          return isValid = false;
        }*/
        if (!this.$$.isValidObj(this.areaId) && this.isArea) {
          this.$message.error("请选择投保人所在地区!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.specificAddress)) {
          this.$message.error("请填写投保人注册地址!");
          return isValid = false;
        }
        if (this.specificAddress.replace(/[^\u0000-\u00ff]/g, "aa").length > 100) {
          this.$message.error("具体地址最多为50个汉字,请重新输入!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.idType)) {
          this.$message.error("请选择证件类型!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.socialCreditCode)) {
          this.$message.error("请输入证件号码!");
          return isValid = false;
        }
        if (this.idType === 6 && idTypeSixReg.test(this.socialCreditCode) === false) {
          this.$message.error("统一社会信用代码格式不合法！");
          return isValid = false;
        }
        if (this.idType === 11 && idTypeElevenRge.test(this.socialCreditCode) === false) {
          this.$message.error("组织机构代码证格式不合法！");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.legalPerson)) {
          this.$message.error("请输入联系人姓名!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.mobile)) {
          this.$message.error("请输入联系人手机号!");
          return isValid = false;
        }
        if (PHONE_REGEX.test(this.mobile) === false) {
          this.$message.error("联系人手机号错误,请重新输入!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.address)) {
          this.$message.error("请输入联系人地址!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.workEmail)) {
          this.$message.error("请输入联系人邮箱!");
          return isValid = false;
        }
        if (EMAIL_REGEX.test(this.workEmail) === false) {
          this.$message.error("联系人邮箱错误,请重新输入!");
          return isValid = false;
        }
        // -- 被保人数据校验
        /*v-for="item in dynamicValidateForm.skuSpecList" v-if="item.value[0].type === 7 && $$.isValidObj(item.value[0].specName) &&
               $$.isValidObj(dynamicValidateForm.attachSkuSpecName) && dynamicValidateForm.attachSkuSpecName !== item.value[0].specName*/
        this.dynamicValidateForm.skuSpecList.forEach(item => {
          if (item.value[0].type === 7 && this.$$.isValidObj(item.value[0].specName) &&
            this.$$.isValidObj(this.dynamicValidateForm.attachSkuSpecName) && this.dynamicValidateForm.attachSkuSpecName !== "0") {
            if (this.$$.isEmptyObject(this.beInsureTableData)) {
              this.$message.error("被保人为空,请上传被保人!");
              return isValid = false;
            }
          }
        });

        // -- 公司不能为被保人校验
        try {
          this.beInsureTableData.forEach(item => {
            if (item.beInsureIdCard === this.socialCreditCode) {
              throw new Error("公司法人不能为被保人!");
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return isValid = false;
        }

        if(this.dynamicValidateForm.productId == '100424'){
            // -- 行业类别
            if (!this.$$.isValidObj(this.restaurantType)) {
                this.$message.error("请选择行业类别!");
                return isValid = false;
            }
            // -- 面积
            if (!this.$$.isValidObj(this.area)) {
                this.$message.error("请填写餐厅面积!");
                return isValid = false;
            }
            // -- 建筑结构
            if (!this.$$.isValidObj(this.buildingStructure)) {
                this.$message.error("请选择建筑结构!");
                return isValid = false;
            }
            // -- 物的类型
            if (this.dynamicValidateForm.planId === 1695 && !this.$$.isValidObj(this.itemTypeL)) {
                this.$message.error("请选择物的类型!");
                return isValid = false;
            }
            if (this.dynamicValidateForm.planId === 1695 && this.$$.isEmptyObject(this.targetList)) {
                this.$message.error("设备列表为空,请填写设备列表!");
                return isValid = false;
            }
        }
        // -- 注册时间
        if (!this.$$.isValidObj(this.beBrithday)) {
          this.$message.error("请选择企业注册时间!");
          return isValid = false;
        }
        // -- 我已阅读
        if (!this.checked) {
          this.$message.error("请先勾选相关协议条款和声明！");
          return isValid = false;
        }
        return isValid;
      },
      //-- 订单数据拼接
      orderData() {
        // -- 主数据
        let orderData = {};
        // -- 计划数据
        let ensurePlan = {};
        // -- 被保人数据
        let beInsureData = {};
        let skuIds = '';
        let sellProductId = '';
        orderData.requestToken = this.requestToken;
        orderData.productId = this.dynamicValidateForm.skuInfo.productId;
        orderData.planId = this.dynamicValidateForm.skuInfo.planId;
        orderData.companyName = this.dynamicValidateForm.companyName.trim();

        skuIds += this.dynamicValidateForm.skuInfo.id + ",";
        sellProductId += this.dynamicValidateForm.skuInfo.sellInsureId + ",";

        skuIds = skuIds.slice(0, skuIds.length - 1);
        sellProductId = sellProductId.slice(0, sellProductId.length - 1);
        orderData.skuId = skuIds;
        orderData.sellProductId = sellProductId

        // -- 投保数据
        orderData.beInsuredEffectiveDate = this.beInsuredEffectiveDate;  // 起保时间
        orderData.companyName = this.dynamicValidateForm.companyName; // 投保单位
        orderData.idType = this.idType;  // 证件类型
        orderData.beBrithday = this.beBrithday.replace(/-/g, ""); // 注册时间
        orderData.socialCreditCode = this.socialCreditCode; // 证件号码
        orderData.companyAddress = this.provinceName + this.cityName + this.areaName + this.specificAddress; // 投保单位地址


        let codeOne = {"area": this.area};
        let restaurantType = {"restaurantType": this.restaurantType};
        let buildingStructure = {"buildingStructure": this.buildingStructure};


        let extendLists = [];
        if (this.dynamicValidateForm.productId == 100435){
            codeOne = {"policyProvinceCode": this.provinceId};
            restaurantType = {"policyCityCode": this.cityId};
            buildingStructure = {"policyAreaCode": this.areaId};
            extendLists.push({"industryCodeLevel4": "L7499"});
        }

        extendLists.push(
          JSON.stringify(codeOne),
          JSON.stringify(restaurantType),
          JSON.stringify(buildingStructure),
        );
        if( this.dynamicValidateForm.planId === 1695 ){
          let map = {"itemTypeL": this.itemTypeL,"list": this.targetList};
          let targetListMap = {"targetList": map};
          extendLists.push(JSON.stringify(targetListMap));
        }
        orderData.extendLists = JSON.stringify(extendLists);
        orderData.address = this.address; // 联系人地址
        orderData.legalPerson = this.legalPerson; // 联系人姓名
        orderData.mobile = this.mobile; // 联系人手机号码
        orderData.workTelephone = this.mobile;
        orderData.credentialsFile = null;
        orderData.workEmail = this.workEmail; // 联系人邮箱
        if (this.$$.isValidObj(this.dynamicValidateForm.attachSkuSpecName) && this.dynamicValidateForm.attachSkuSpecName !== '0') {
          this.beInsureTableData.forEach(item => {
            let beInsureMap = {};
            beInsureMap.beInsureName = item.beInsureName; // 被保人姓名
            beInsureMap.beInsureIdCard = item.beInsureIdCard; // 被保人证件号
            beInsureMap.beSkuId = this.dynamicValidateForm.skuInfo.id; // 被保人skuId
            beInsureMap.beInsureIdType = item.beInsureIdType; // 被保人证件类型
            beInsureMap.beSex = item.beSex; // 被保人性别
            beInsureMap.realityOccCode = item.realityOccCode; // 被保人职业代码
            beInsureMap.beBrithday = item.beBirthday; // 被保人出生日期
            beInsureData[item.beInsureIdCard] = beInsureMap;
          });
        }
        let beInsureCompanyMap = {};
        beInsureCompanyMap.beInsureName = this.dynamicValidateForm.companyName;
        beInsureCompanyMap.beInsureIdCard = this.socialCreditCode;
        beInsureCompanyMap.beSkuId = JSON.parse(this.dynamicValidateForm.skuInfo.ensureChar).group.split(",")[0]; // 被保人skuId
        beInsureCompanyMap.beInsureIdType = this.idType; // 被保人证件类型
        beInsureCompanyMap.beSex = "O";
        beInsureCompanyMap.beBrithday = this.beBrithday.replace(/-/g, ""); // 被保人出生日期
        beInsureData[this.socialCreditCode] = beInsureCompanyMap;


        // -- ensurePlan内部数据
        let map = {};

        // -- 人数
        map.groupSize = 1;
        this.dynamicValidateForm.groupSize = 1;
        // -- 计划SkuId
        map.skuId = this.dynamicValidateForm.skuInfo.id;
        // -- 职业Id
        map.occId = 0;
        /*v-for="item in dynamicValidateForm.skuSpecList" v-if="item.value[0].type === 7 && $$.isValidObj(item.value[0].specName) &&
         $$.isValidObj(dynamicValidateForm.attachSkuSpecName) && dynamicValidateForm.attachSkuSpecName !== item.value[0].specName*/

        if ( this.$$.isValidObj(this.dynamicValidateForm.attachSkuSpecName) && this.dynamicValidateForm.attachSkuSpecName !== "0") {
            // -- 人数
            map.groupSize = this.beInsureTableData.length;
            this.dynamicValidateForm.groupSize = this.beInsureTableData.length;
        }
        // if(this.dynamicValidateForm.productId == '100435'){
        //     map.groupSize = Object.getOwnPropertyNames(beInsureData).length;
        //     this.dynamicValidateForm.groupSize = Object.getOwnPropertyNames(beInsureData).length;
        // }
        ensurePlan[0] = map;

        orderData.ensurePlan = JSON.stringify(ensurePlan);

        orderData.beInsureData = JSON.stringify(beInsureData);
        // -- 发票数据
        orderData.needInvoices = this.needInvoices;      // true 需要发票  false 不需要发票
        if (this.$$.isValidObj(this.dynamicValidateForm.beShareToken)) orderData.beShareToken = decodeURIComponent(encodeURIComponent(this.dynamicValidateForm.beShareToken).replace(/%20/g, "+"));
        return orderData;
      },
      //-- 立即投保跳转
      submitOrder() {

        if (!this.dataIsValid()) {
          return;
        }

        this.submitOrderData = this.orderData();
        let loadingInstance = Loading.service({fullscreen: true});
        this.axios.post('/management/mobileBusinessInsurance/rule_fillInsuranceInfo_verify', this.submitOrderData).then((response) => {
          if (response.data.success) {
            //-- 会话存储 - 参数
            sessionStorage.setItem('siNoSafeAllData' + this.dynamicValidateForm.productId, JSON.stringify(this.$data));
            this.$router.push({name: 'siNoSafeInsureConfirm' , query: {productId : this.dynamicValidateForm.productId } });
          } else {
            this.$message.error(response.data.msg);
          }
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        });
      },
    },
    mounted() {
          let productId = this.$route.query.productId;
      let siNoSafeDynamicValidateForm = sessionStorage.getItem('siNoSafeDynamicValidateForm' + productId);
      let siNoSafeAllData = sessionStorage.getItem('siNoSafeAllData' + productId);
      if (this.$$.isValidObj(siNoSafeAllData) && siNoSafeAllData != 'undefined') {
        siNoSafeAllData = JSON.parse(siNoSafeAllData);
        Object.assign(this.$data, siNoSafeAllData);
        this.pickerOptions.disabledDate = this.disabledDate;
      } else if (this.$$.isValidObj(siNoSafeDynamicValidateForm)) {
        this.dynamicValidateForm = JSON.parse(siNoSafeDynamicValidateForm);
        if(this.dynamicValidateForm.productId == 100435 ) {
            this.chinaArea =  this.sinosafeAccidentDistrict.pinganChinaAreaList() ;
        }
          this.getSkuInfo();
      } else {
        this.$confirm('当前订单参数错误，请重新进入~', '温馨提示：', {
          showClose: false,
          closeOnClickModal: false,
          center: true,
          showCancelButton: false,
          confirmButtonText: '确认',
        }).then(() => {
          this.$router.push({name: 'sinosafeInsureManagement'});
        });
      }
      this.getInsuranceClause();
    }
  }

</script>

<style scoped>

  .box-card {
    width: auto;
    height: auto;
    padding: 20px;
    margin-bottom: 2.5rem;
  }

  .box-card-div {
    position: relative;
  }

  .box-card-div-title {
    height: 12px;
    background: #FFBF00;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 10px;
    display: inline-block;
    position: relative;
  }

  .box-card-div > span {
    position: absolute;
    right: 0;
    top: -20px;
  }

  .box-card-div-title.userInfo {
    width: 96px;
  }

  .supportPlan {
    width: 120px;
  }

  .box-card-div-title > .header {
    text-align: center;
    position: absolute;
    left: 0;
    top: -20px;
  }

  .box-card-div > span {
    display: inline-block;
    float: right;
  }


  .form-item-label {
    font-size: 1rem;
    font-weight: 500;
    color: #333333;
    margin: 0 auto 10px;
    position: relative;
  }

  .form-item-label-add {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    text-align: left;
    padding-top: 5px;
    margin-bottom: 4px !important;
  }


  .form-item-label-big {
    font-weight: bold;
    color: #333333;
    margin-top: -10px;
  }

  .form-item-label-big /deep/ .el-form-item__content {
    padding-left: 10px;
  }

  .header-span {
    font-size: 1rem;
    font-weight: 400;
    color: #333333;
  }

  .form-item-input {
    height: 40px;
    width: 144px;
    max-width: 640px;
    background: #F7F7F7;
    margin: 0 5px 5px 10px;
    text-align: center;
    display: inline-block;
  }

  .form-item-input-add {
    background: #F7F7F7 !important;
  }

  /deep/ .header-content {
    text-align: center;
  }

  .p-title {
    font-size: 2.5rem;
    color: #333333;
    font-weight: bold;
    font-style: italic;
  }

  .row-bg {
    padding: 60px 0 40px;
  }

  .submitOrder {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  .header-button-order-add {
    width: 20rem;
    background: #FF7052 !important;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    margin-top: 25px;
  }

  .header-button-order-add:hover {
    color: #FFFFFF !important;
    background: #FF7052 !important;
  }

  .my-button {
    margin-right: 30px;
    background-color: #F7F7F7;
  }

  .header-row-col-button-success {
    width: auto;
    height: 40px;
    background-color: #528BFF !important;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    margin: 0 30px 5px 0;
    border-radius: 12px !important;
    border: 0 !important;
  }

  .header-row-col-button-success a {
    color: #ffffff;
    border: none;
  }

  .header-row-col-button-success a:link {
    text-decoration: none;
  }

  .header-row-col-button-failure {
    width: auto;
    height: 40px;
    background-color: #FF7052 !important;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    margin-right: 30px;
    border-radius: 12px !important;
    border: 0 !important;
  }

  .header-row-col-button-success:hover {
    color: #FFFFFF !important;
    background: #528BFF !important;
  }

  .header-row-col-button-failure:hover {
    color: #FFFFFF !important;
    background: #FF7052 !important;
  }

  .my-el-table {
    width: 900px;
  }

  .my-el-date-picker {
    width: calc(100% - 25px) !important;
    min-width: 144px;
    margin-left: 10px;
  }

  .my-el-date-picker-add {
    width: 264px !important;
  }

  .header-row-col-button-success-add {
    width: 144px;
    height: 40px;
    background-color: #FF7052 !important;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    border-radius: 12px !important;
    border: 0 !important;
    margin-left: 20px;
  }

  .header-row-col-button-failure-add {
    width: 144px;
    height: 40px;
    background-color: #D9D9D9 !important;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    border-radius: 12px !important;
    border: 0 !important;
    margin-right: 20px;
  }

  .header-row-col-button-success-add:hover {
    color: #FFFFFF !important;
    background: #FF7052 !important;
  }

  .header-row-col-button-failure-add:hover {
    color: #FFFFFF !important;
    background: #D9D9D9 !important;
  }

  .my-step {
    padding-top: 63px;
  }

  /* 已完成title文字颜色 */
  .my-step /deep/ .is-finish {
    font-size: 1rem;
    font-weight: 500;
    font-style: italic;
    color: #FF7052;
  }

  /* 进行中title文字颜色 */
  .my-step /deep/ .is-process {
    font-size: 1rem;
    font-weight: 500;
    font-style: italic;
    color: #FF7052;
  }

  /* 等待中title文字颜色*/
  .my-step /deep/ .is-wait {
    font-size: 1rem;
    font-weight: 500;
    font-style: italic;
    color: #666666;
  }

  /* 圆圈数字颜色*/
  .my-step /deep/ .el-step__icon-inner {
    padding-right: 6px;
    font-size: 1.5rem;
    font-style: italic !important;
    font-weight: 800;
    color: #FFFFFF;
  }

  /* 圆圈数字颜色*/
  .my-step /deep/ .el-step__icon-inner:before {
    content: '0';
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-finish .is-text {
    background: #EB6F67 !important;
    border-color: #EB6F67 !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-process .is-text {
    background: #EB6F67 !important;
    border-color: #EB6F67 !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-wait .is-text {
    background: #CCCCCC !important;
    border-color: #CCCCCC !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-finish 圆圈颜色*/
  .my-step /deep/ .el-steps.el-steps--horizontal {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;

  }

  .my-step /deep/ .el-step.is-horizontal.is-center {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;
  }

  .my-step /deep/ .el-step__head.is-finish {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;
  }

  /*is-process 圆圈颜色*/
  .my-step /deep/ .el-steps.el-steps--horizontal {
    color: #FF7052;
    border-color: #FF7052;
  }

  .my-step /deep/ .el-step__head.is-process {
    color: #FF7052;
    border-color: #FF7052;
  }

  .my-step /deep/ .el-step.is-horizontal.is-center {
    color: #FF7052;
    border-color: #FF7052;
  }

  /* 输入框去圆角 */
  .my-input /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 1rem;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
  }

  .my-input-left {
    width: calc(100% - 35px);
    min-width: 144px;
  }

  .my-el-date-picker {
    max-width: 640px;
  }

  /* 输入框文字左对齐 */
  .my-input-left /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: left !important;
  }

  /* 必填框去掉*号 */
  .form-item-label /deep/ .el-form-item__label:before {
    color: #FFFFFF !important;
    margin-right: 0 !important;
    content: '' !important;
  }

  .form-item-label /deep/ .el-form-item__label {
    font-size: 1rem !important;
    margin: 0 auto;
  }

  /* 必填框去掉*号 */
  .form-item-label-big /deep/ .el-form-item__label:before {
    color: #FFFFFF !important;
  }

  .form-item-label-big /deep/ .el-form-item__label {
    font-size: 1.25rem !important;
    font-weight: bold;
  }

  /* 必填框去掉*号 */
  .form-item-label-add /deep/ .el-form-item__label:before {
    color: #FFFFFF !important;
  }

  .form-item-label-add /deep/ .el-form-item__label {
    font-size: 16px !important;
    width: 100px !important;
    text-align: right !important;
    padding-right: 25px !important;
  }

  .underwriterDetailed /deep/ .el-form-item__content {
    padding-left: 10px;
  }

  .el-dialog__wrapper /deep/ .el-form-item__content {
    margin-left: 100px !important;
  }

  /* 取出radio圆角 */
  .my-button .el-radio-button:first-child /deep/ .el-radio-button__inner {

  }

  /* 选择项的颜色 */
  .is-active /deep/ .el-radio-button__inner {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    background-color: #FFEEEB !important;
    color: #FF7052 !important;
    border: 1px solid #FF7052 !important;
  }

  .my-button /deep/ .el-radio-button__inner {
    box-shadow: 0 0 0 0 !important;
    -webkit-box-shadow: 0 0 0 0 !important;
    border: 0;
    border-radius: 0 !important;
    background-color: #F7F7F7;
    color: #333333;
  }

  .el-radio-button:first-child /deep/ .el-radio-button__inner {
    border-left: 0;
  }

  .is-active /deep/ .el-radio-button__inner:hover {
    color: #FF7052 !important;
  }

  .my-button /deep/ .el-radio-button__inner:hover {
    color: #333333;
  }

  .el-input--prefix /deep/ .el-input__inner {
    text-align: center !important;
    background-color: #F7F7F7;
    border: 0;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    padding: 0 30px 0 10px;
  }

  /deep/ .el-dialog--center {
    box-shadow: 0 12px 28px 0 rgba(204, 204, 204, 0.25) !important;
    border-radius: 16px !important;
  }

  .el-dialog--center /deep/ .el-dialog__body {
    text-align: center !important;
    padding: 15px 25px 10px;
  }

  .dialog-footer {
    margin: 20px auto;
    text-align: center;
  }

  /* 新增被保人输入框去圆角 */
  .my-input-add /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
    padding: 0 30px 0 10px;
  }

  /deep/ .el-dialog__title {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
  }

  /deep/ .el-dialog__header {
    padding: 40px 20px 0;
  }

  .el-dialog__headerbtn /deep/ .el-dialog__close {
    font-weight: bold;
    font-size: 2rem;
  }

  .box-card /deep/ .is-leaf {
    background: #f0f0f0;
    text-align: center;
    line-height: 0;
  }

  .specialTip {
    width: 1rem;
    height: 1rem;
    padding: 0;
    border-radius: 50%;
    border: 1px solid #F2613F;
    display: inline-block;
    text-align: center;
    font-size: .75rem;
    line-height: 10px;
    top: calc((40px - 1rem) / 2);
    left: 165px
  }

  .specialTip:before {
    width: 1rem;
    height: 1rem;
    content: '?';
    font-weight: bold;
    color: #F2613F;
  }

  .el-checkbox-span-a {
    display: inline-block;
  }

  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  /deep/ .el-dropdown {
    font-size: inherit !important;
  }

  .select-arrowhead /deep/ .el-select__caret {
    display: none;
  }

  .true {
    color: #FFFFFF !important;
    background-color: #f2613f !important;
    height: 40px;
    width: 144px;
    max-width: 640px;
    margin: 0 5px 5px 10px;
    text-align: center;
    display: inline-block;
  }

  .false {
    height: 40px;
    width: 144px;
    max-width: 640px;
    background: #F7F7F7;
    margin: 0 5px 5px 10px;
    text-align: center;
    display: inline-block;
  }

  /* 输入框文字左对齐 */
  .true /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF !important;
    background-color: #f2613f !important;
    text-align: left !important;
  }

  /* 输入框文字左对齐 */
  .false /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: left !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/product/sinosafeInsurance/siNoSafeInsureDetails.vue